import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const SubTabs = ({ name, link, isFirstTab }) => {
  const location = useLocation();

  // When at the index route (/marketing without a sub-path), the first tab
  // should appear active since the index route renders its content
  const pathname = location.pathname.replace(/\/+$/, '');
  const isOnIndexRoute = isFirstTab && pathname.endsWith('/marketing');

  return (
    <>
      <NavLink
        to={link}
        className={({ isActive }) =>
          (isActive || isOnIndexRoute)
            ? "p-1 border-b-2 border-primary-500  flex px-4 py-2 text-primary-500 justify-start items-start gap-2  text-xs font-bold leading-none"
            : "p-1  flex px-4 py-2 justify-start items-start gap-2 text-text-hint text-xs font-normal leading-none"
        }
      >
        {name}
      </NavLink>
    </>
  );
};

export default SubTabs;
